import { BaseWebComponentView } from '../../framework/BaseWebComponentView';
import { DATA_LOADED_EVENT, EndpointDetailsWebComponentSchema } from '../types';
import { htmlEncode } from '../../utils/escape.utils';
import { TemplateState } from '../../types/common/types';

export class EndpointDetailsView extends BaseWebComponentView {
  getDomElements() {
    this.dom.$wrapper = this.shadow.querySelector('.wrapper');

    this.dom.$title = this.shadow.querySelector('#title');
    this.dom.$name = this.shadow.querySelector('#name');
    this.dom.$ip = this.shadow.querySelector('#ip');
    this.dom.$os = this.shadow.querySelector('#os');
    this.dom.$label = this.shadow.querySelector('#label');

    this.dom.$nameContent = this.shadow.querySelector('#name-content');
    this.dom.$ipContent = this.shadow.querySelector('#ip-content');
    this.dom.$osContent = this.shadow.querySelector('#os-content');
    this.dom.$labelContent = this.shadow.querySelector('#label-content');

    this.dom.$nameTooltip = this.shadow.querySelector('#name-tooltip');
    this.dom.$ipTooltip = this.shadow.querySelector('#ip-tooltip');
    this.dom.$osTooltip = this.shadow.querySelector('#os-tooltip');
    this.dom.$labelTooltip = this.shadow.querySelector('#label-tooltip');

    this.dom.$errorMessage = this.shadow.querySelector('#error-message');

    this.getTranslations();
    this.setTranslatedStrings();

    this.setTemplateState(this.dom.$wrapper, TemplateState.LOADING);
  }

  getTranslations() {
    this.translations = this.stringsTranslator.getEndpointDetailsString();
    this.commonStrings = this.stringsTranslator.getCommonStrings();
  }

  public setTranslatedStrings() {
    const { title, name, ip, os, label } = this.translations;

    this.dom.$title.innerText = title;
    this.dom.$name.label = name;
    this.dom.$ip.label = ip;
    this.dom.$os.label = os;
    this.dom.$label.label = label;
  }

  buildSuccessView(data: EndpointDetailsWebComponentSchema) {
    const { name, ip, operatingSystem, label } = data;

    this.dom.$nameTooltip.tooltipText = this.dom.$nameContent.innerText = name;
    this.dom.$ipTooltip.tooltipText = this.dom.$ipContent.innerText = ip;
    this.dom.$osTooltip.tooltipText = this.dom.$osContent.innerText =
      this.dependencies.Ext.translateOperatingSystem(operatingSystem);
    this.dom.$labelTooltip.tooltipText = this.dom.$labelContent.innerText = label || this.commonStrings.notApplicable;

    this.resetTemplateState(this.dom.$wrapper);

    this.dom.$wrapper.dispatchEvent(
      new CustomEvent(DATA_LOADED_EVENT, {
        detail: {
          endpoint: data,
        },
        bubbles: true,
        composed: true,
      })
    );
  }

  public buildErrorView(error: Error) {
    this.resetTemplateState(this.dom.$wrapper);
    this.setTemplateState(this.dom.$wrapper, TemplateState.ERROR);

    this.dom.$errorMessage.innerText = this.translations.errorMessage;

    this.dom.$wrapper.dispatchEvent(
      new CustomEvent(DATA_LOADED_EVENT, {
        detail: {
          endpoint: null,
        },
        bubbles: true,
        composed: true,
      })
    );
  }
}
